
export function removeNullChildren(data) {
  for (var i = 0; i < data.length; i++) {
    if (data[i].children.length < 1) {
      data[i].children = undefined;
    } else {
      removeNullChildren(data[i].children)
    }
  }
  return data;
}

export function getIdAndChildren(data,ids) {
  for (var i = 0; i < data.length; i++) {
    ids.push(data[i].id);
    if (data[i].children.length >= 1) {
      getIdAndChildren(data[i].children,ids)
    }
  }
  return ids;
}
